import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import processRealtimeData from '../utilities/ProcessRealtimeZoneHelper';

const ZoneCard = ({ zoneRealtimeData, selectZone, setZoneHealth }) => {
  const formattedZoneRealtime = processRealtimeData(zoneRealtimeData);
  let hasTemperature = formattedZoneRealtime.currentTemperature !== 'N/A';

  useEffect(() => {
    setZoneHealth(formattedZoneRealtime.zoneStatusCSS);
  }, [zoneRealtimeData]);

  return (
    <>
      <ZoneCardTr>
        <td className="location " onClick={selectZone}>
          <div className={'zone-health-indicator ' + formattedZoneRealtime.zoneStatusCSS}></div>
          {zoneRealtimeData && zoneRealtimeData.longThermalZoneDisplayName}
        </td>

        <td className="status">
          <div className={'status ' + formattedZoneRealtime.zoneStatusCSS}>
            {formattedZoneRealtime.zoneStatus}
          </div>
        </td>

        <td className="temp-range">
          {hasTemperature && (
            <div className="zone-thermostat-container">
              <p className="current">{formattedZoneRealtime.currentTemperature}°</p>

              <p className="range">
                {formattedZoneRealtime.temperatureLowerBound !== null &&
                  formattedZoneRealtime.temperatureUpperBound !== null && (
                    <>
                      {formattedZoneRealtime.temperatureLowerBound}° -{' '}
                      {formattedZoneRealtime.temperatureUpperBound}°
                    </>
                  )}
              </p>
            </div>
          )}
        </td>

        <td className="schedule">{formattedZoneRealtime.scheduleOrOverride}</td>

        <td className="activity">{formattedZoneRealtime.activityState}</td>

        <td className="keypad">{formattedZoneRealtime.keypadLock}</td>

        <td className="managed">{formattedZoneRealtime.controlState}</td>
      </ZoneCardTr>
    </>
  );
};

const ZoneCardTr = styled.tr`
  .location {
    align-items: center;
    display: flex;
    font-size: 14px;
    font-weight: 600;

    .zone-health-indicator {
      border-right: 0;
      border-top: 0;
      border-bottom: 0;
      height: 40px;
      margin-right: 12px;
      min-width: 5px;

      &.healthy {
        background-image: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 10%,
          #00dc92 10%,
          #00dc92 90%,
          transparent 90%,
          transparent 100%
        );
      }

      &.warn {
        background-image: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 10%,
          #fa974f 10%,
          #fa974f 90%,
          transparent 90%,
          transparent 100%
        );
      }

      &.unhealthy {
        background-image: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 10%,
          #f96138 10%,
          #f96138 90%,
          transparent 90%,
          transparent 100%
        );
      }

      &.offline {
        background-image: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 10%,
          #edf1f2 10%,
          #edf1f2 90%,
          transparent 90%,
          transparent 100%
        );
      }

      &.unmanaged {
        background-image: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 10%,
          #92a5a8 10%,
          #92a5a8 90%,
          transparent 90%,
          transparent 100%
        );
      }
    }
  }

  .status {
    border-radius: 50px;
    font-size: 12px;
    font-weight: 600;
    padding: 6px;
    text-align: center;
    width: 110px;

    &.healthy {
      background: rgba(0, 220, 146, 0.3);
      color: #006140;
    }

    &.warn {
      background: rgba(250, 151, 79, 0.3);
      color: #863f0b;
    }

    &.unhealthy {
      background: rgba(249, 97, 56, 0.3);
      color: #7e230a;
    }

    &.offline {
      background: rgba(237, 241, 242, 0.3);
    }

    &.unmanaged {
      background: rgba(146, 165, 168, 0.3);
    }
  }

  .temp-range .zone-thermostat-container {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100px;

    p {
      margin: 0;
    }

    .current {
      font-size: 18px;
      font-weight: 800;
      line-height: 20px;
    }

    .range {
      color: #62797e;
      font-size: 13px;
    }
  }

  .activity .activity-state,
  .keypad .keypad-status {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    .status,
    .managed,
    .schedule {
      display: none;
    }
  }
`;

export default ZoneCard;
